import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { AbstractIcon } from "./IconButton";
import type { IconName } from "./AbstractIcon";
type SectionProps = {
  iconName: IconName;
  title: string;
  onPress: () => void;
};
export type SectionListItems = Array<{
    key: string;
    iconName: IconName;
    title: string;
    onPress: () => void;
  }>
type SectionListProps = {
  items: SectionListItems;
};

function SectionButton(props: SectionProps) {
  return <TouchableOpacity onPress={props.onPress}>
      <View style={styles.buttonContainer}>
        <View style={styles.icon}>
          <AbstractIcon name={props.iconName} size={24} color="black" />
        </View>
        <Text style={styles.buttonHeaderText}>{props.title}</Text>
      </View>
    </TouchableOpacity>;
}

export default function SectionList(props: SectionListProps) {
  const buttons = props.items.map(item => <SectionButton key={item.key} onPress={item.onPress} title={item.title} iconName={item.iconName} />);
  return <View style={styles.container}>{buttons}</View>;
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "stretch",
    alignSelf: "center",
    maxWidth: 600
  },
  buttonContainer: {
    margin: 10,
    borderColor: "black",
    borderWidth: 1,
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 48,
    paddingRight: 30,
    borderRadius: 10
  },
  buttonHeaderText: {
    fontSize: 20
  },
  icon: {
    position: "absolute",
    top: 7,
    bottom: 7,
    left: 12,
    flex: 1,
    alignItems: "center",
    justifyContent: "center"
  }
});